import script from "./AreaInspecaoForm_12.vue?vue&type=script&setup=true&lang=js"
export * from "./AreaInspecaoForm_12.vue?vue&type=script&setup=true&lang=js"

import "./AreaInspecaoForm_12.vue?vue&type=style&index=0&id=ddc43a3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddc43a3c"]])

export default __exports__